export default "__VITE_ASSET__BnmCxFPb__"